var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.cdata.seriesData && _vm.cdata.seriesData.length ? _vm.cdata.seriesData[0].name : 'default',ref:"chart",staticStyle:{"width":"300px","height":"340px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }